import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=305af459&scoped=true"
import script from "./ClassView.vue?vue&type=script&lang=js"
export * from "./ClassView.vue?vue&type=script&lang=js"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=305af459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305af459",
  null
  
)

export default component.exports